import Fallback from "./Components/Fallback";

function App() {
  return (
    <div className="App">
      <Fallback />
    </div>
  );
}

export default App;
